import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { signInModule } from './modules/signIn';
import { readmeModule } from './modules/readme';
import { catalogGraphModule } from './modules/catalogGraph';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    homeModule,
    signInModule,
    readmeModule,
    catalogGraphModule,
  ],
});
